import { Tabs } from '@shopify/polaris';

interface IHeader {
  selectedTab: string;
  tabs: { id: string; content: string }[];
  setSelectedTab: (tabIndex: string) => void;
}
export const TabContainer: React.FC<IHeader> = ({ selectedTab, tabs, setSelectedTab }) => {
  const onChangeTab = (tabIndex: number) => {
    setSelectedTab(tabs[tabIndex].id);
  };
  if (tabs.length === 0) return null;

  return (
    <Tabs
      tabs={tabs}
      selected={tabs.findIndex((tab) => tab.id === selectedTab)}
      onSelect={onChangeTab}
    />
  );
};
